import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/mfeLzH2T8ak3XUBgu5ARXa/ChatGPT_Image_15_jul_2026,_10_09_44_a.m..png';
const bullets = ['315+ pages', '500+ supports cliniques', '10 domaines', '5 outils complémentaires offerts'];
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-black px-4 pt-7 pb-12 sm:pt-9" data-id="element-117">
      {/* soft golden glow */}
      <div className="pointer-events-none absolute left-1/2 top-[38%] -z-0 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-gold/10 blur-[120px]" data-id="element-118" />

      <div className="relative z-10 mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-119">
        <motion.span initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mb-3 inline-flex items-center gap-1 rounded-full border border-gold/40 bg-gold/10 px-2.5 py-1 text-[8px] font-bold uppercase tracking-[0.08em] text-gold sm:text-[10px]" data-id="element-120">
          🧠 Le protocole clinique n°1 pour les professionnels
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="max-w-3xl font-display text-3xl uppercase leading-tight tracking-tight text-white sm:text-4xl md:text-5xl" data-id="element-121">
          Ne préparez plus jamais une séance à partir de zéro.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.12
      }} className="mt-3 max-w-xl text-center text-sm leading-relaxed text-white/60 sm:text-base" data-id="element-122">
          Le système clinique complet qui organise toutes vos interventions en{' '}
          <span className="font-semibold text-gold" data-id="element-123">
            moins de 5 minutes. PRÊT À L'EMPLOI.
          </span>
        </motion.p>

        <motion.ul initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.18
      }} className="mt-3 grid w-full max-w-lg grid-cols-2 justify-items-center gap-x-2 gap-y-1 text-center" data-id="element-124">
          {bullets.map(bullet => <li key={bullet} className="flex items-center justify-center gap-1 whitespace-nowrap text-[9px] font-semibold leading-none tracking-tight text-white/85 sm:gap-1.5 sm:text-[11px]" data-id="element-125">
              <span className="text-[9px] sm:text-[11px]" data-id="element-126">✅</span> {bullet}
            </li>)}
        </motion.ul>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.24
      }} className="mt-4 w-full" data-id="element-127">
          <img src={HERO_IMG} alt="Le Protocole Clinique en 4 étapes avec ses cinq outils complémentaires" className="mx-auto w-full max-w-2xl rounded-2xl" data-id="element-128" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.34
      }} className="mt-4 w-full max-w-xl" data-id="element-129">
          <CTAButton href="#pack" size="large" data-id="element-130">
            🚀 Je veux accéder au kit maintenant
          </CTAButton>
          <div className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/60" data-id="element-131">
            <span className="flex items-center gap-1.5" data-id="element-132">
              🔒 Paiement sécurisé
            </span>
            <span className="flex items-center gap-1.5" data-id="element-133">⚡ Accès immédiat</span>
            <span className="flex items-center gap-1.5" data-id="element-134">
              🛡️ Garantie 7 jours
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}